import { render, staticRenderFns } from "./IconContainer.vue?vue&type=template&id=513e4c83&scoped=true&"
import script from "./IconContainer.vue?vue&type=script&lang=ts&"
export * from "./IconContainer.vue?vue&type=script&lang=ts&"
import style0 from "./IconContainer.vue?vue&type=style&index=0&id=513e4c83&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513e4c83",
  null
  
)

export default component.exports